export enum CustomCapMapping {
  SDSCAP = 'SDSCAP',
  CAP = 'CAP',
}
